import React from 'react';

const LoadingRefreshtoken = () => (
  <div className="text-left" style={{marginLeft:"15px"}}>
    <i className="fa fa-spinner fa-spin" /> Token is being Regenerated. Please wait...
  </div>
);

export default LoadingRefreshtoken;